import { Dayjs } from 'dayjs';
import { ApprovalType, PaymentSource } from './company';

export enum TransactionStatus {
    PendingApproval = 'PendingApproval',
    ActionInProgress = 'ActionInProgress',
    AwaitingBank = 'AwaitingBank',
    AwaitingDeposit = 'AwaitingDeposit',
    Authorized = 'Authorized',
    Succeeded = 'Succeeded',
    Failed = 'Failed',
    Rejected = 'Rejected',
    Expired = 'Expired'
}

export type TransactionUser = {
    userId: string;
    userName: string;
    email: string;
    balance: number;
    withdrawed: number;
    percentageWithdrawed: number;
};

export interface Transaction {
    transactionId: string;
    createdAt: Dayjs;
    performedAt?: Dayjs; // made optional as in the interface
    amount: number;
    withdrawalFee: number;
    totalAmount: number;
    balance: number;
    currency: string;
    userId: string | null; // kept as string | null from the type
    userIsDeleted: boolean;
    transactionType: string;
    userName: string;
    executantAdminEmail: string;
    executantAdminName?: string;
    status: TransactionStatus;
    approvalType: ApprovalType;
    paymentSource?: PaymentSource;
    companyName?: string;
}

export type TransactionDetailed = {
    transactionId: string;
    createdAt: Dayjs;
    companyName: string;
    amount: number;
    currency: string;
    user: TransactionUser;
    status: TransactionStatus;
    withdrawalFee: number;
    totalAmount: number;
};

export type TransactionsResponse = {
    transactions: Array<Transaction>;
    total: number;
};

export type TransactionsDetailedResponse = {
    transactions: Array<TransactionDetailed>;
    total: number;
};
